import Token from '@/utils/Token';

export default {

    parse(data) {
        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/cidade/${id}${params}`, Token.getHeader());
    },
    ufNome(uf, nome) {
        return axios.get(`/api/cidade/ufNome/${uf}/${nome}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/cidade/list${params}`, Token.getHeader());
    },
    option(estadoId, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/cidade/option/${estadoId}${params}`, Token.getHeader());
    },
    optionStr(estadoId, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/cidade/optionStr/${estadoId}${params}`, Token.getHeader());
    },

    create(params) {
        return axios.post(`/api/cidade`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/cidade/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/cidade/${id}`, Token.getHeader());
    },
}